import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/GuestListConstants';


export default {

    checkGuestIn:(formData) => {
        return AjaxPromises.POST(EndPoints.CHECK_GUEST_IN, formData);
    },

    checkGuestInToPOS: (formData) => {
        return AjaxPromises.POST(EndPoints.CHECK_GUEST_INTO_POS, formData);
    },

    checkGuestOut:(formData) => {
        return AjaxPromises.POST(EndPoints.CANCEL_TRANSACTION, formData);
    },

    scan:(formData) => {
        return AjaxPromises.POST(EndPoints.SCAN, formData);
    },

    loadGuestList:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_GUEST_LIST, formData);
    },

    selectGuestForPos:(formData) => {
        return AjaxPromises.POST(EndPoints.GUEST_TO_REGISTER, formData);
    },

    releaseGuestFromPos:(formData) => {
        return AjaxPromises.POST(EndPoints.REMOVE_GUEST_FROM_REG, formData);
    },

    search:(formData) => {
        return AjaxPromises.POST(EndPoints.SEARCH_BY_NAME, formData);
    },

    biotrackScanGuestIn:(formData) => {
        return AjaxPromises.POST(EndPoints.BIOTRACK_SCAN_GUEST_IN, formData);
    },

    getStatusList:(formData) => {
        return AjaxPromises.POST(EndPoints.GET_STATUS_LIST, formData);
    },

    getDefaultStatus:(formData) => {
        return AjaxPromises.POST(EndPoints.GET_DEFAULT_STATUS, formData);
    },

    authPusherChannel:(formData) => {
        return AjaxPromises.POST(EndPoints.AUTH_PUSHER_CHANNEL, formData)
    },

    getPusherConfig: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_PUSHER_CONFIG, formData)
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/api/GuestListApi.jsx